module.exports = __webpack_public_path__ + "media/Bazel.4b3ebfc9.mp4";